import { Text } from '~/components/ui/Text';
import levelBottom from '../../assets/images/level_bottom.svg';
import {
	StyledContainer,
	StyledCurrentLevelText,
	StyledDisabledLevelText,
	StyledLevelText,
	StyledTopContainer,
} from './LevelCard.styled';

const LevelCard = ({
	level,
	text,
	active,
	disabled,
}: {
	level: number;
	text: string;
	active?: boolean;
	disabled?: boolean;
}) => {
	return (
		<StyledContainer $active={active} $disabled={disabled}>
			<StyledTopContainer>
				<StyledLevelText $disabled={disabled}>{level} уровень</StyledLevelText>
				{active && (
					<StyledCurrentLevelText>Текущий уровень</StyledCurrentLevelText>
				)}
				{disabled && <StyledDisabledLevelText>Получен</StyledDisabledLevelText>}
			</StyledTopContainer>
			<Text>{text}</Text>
			{active && <img src={levelBottom} />}
		</StyledContainer>
	);
};

export { LevelCard };
